export default __webpack_public_path__ + "static/rachna-c7dca516d1a2ea2003ce359f90a5963d.png";